import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PrivacyPolicyContent } from "@/components/legal/PrivacyPolicyContent";
import { TermsContent } from "@/components/legal/TermsContent";

const DOCS = {
  privacy: { title: "Privacy Policy", Content: PrivacyPolicyContent },
  terms: { title: "Terms & Conditions", Content: TermsContent },
};

/**
 * Full-screen, in-app legal reader. Rendered as an overlay (not a route swap) so
 * the underlying screen — e.g. a half-filled apply form — stays mounted and keeps
 * its state. Visibility is driven by the /legal/* route in App.js, so the Android
 * back gesture closes it natively; iOS PWAs (which have no back gesture) use the
 * ← button. Content is HTML, so it renders reliably where a PDF traps the user.
 */
export const LegalPage = ({ doc }) => {
  const navigate = useNavigate();
  const { title, Content } = DOCS[doc] || DOCS.privacy;

  const goBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <div className="fixed inset-0 z-[80] overflow-y-auto bg-brand-canvas text-brand-ink">
      <header className="sticky top-0 z-10 border-b border-black/5 bg-brand-canvas/90 backdrop-blur">
        <div className="mx-auto flex max-w-[720px] items-center gap-3 px-4 py-3.5">
          <button
            type="button"
            onClick={goBack}
            aria-label="Back"
            className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-black/10 bg-white text-brand-ink transition hover:bg-black/[.03]"
          >
            <ArrowLeft size={18} />
          </button>
          <h1 className="brand-title text-lg font-semibold">{title}</h1>
        </div>
      </header>
      <main className="mx-auto max-w-[720px] px-5 py-6 pb-20">
        <Content />
      </main>
    </div>
  );
};
